import React, { useState, useEffect } from "react";
import {
  Offcanvas,
  Row,
  Col,
  OffcanvasBody,
  Button,
  Collapse,
  Spinner,
} from "reactstrap";
import "../CandidateStaticReport.scss";
import CountryFilter from "./CountryFilter";
import ClientFilter from "./ClientFilter";
import RecruiterFilter from "./RecruiterFilter";
import SalesFilter from "./SalesFilter";
import DateRangeFilter from "./DateRangeFilter";
import CurrentStageFilter from "./CurrentStageFilter";
import { useSelector, useDispatch } from "react-redux";
import { saveCandidateStaticReportFilters } from "../../../store/candidate/action";
import { fetchUsers } from "@workspace/common/src/store/actions";
import { fetchAccountNamesAll } from "@workspace/common/src/store/accountnames/action";
import { fetchCountryCurrency } from "@workspace/common/src/store/actions";

import {
  INITAL_CANDIDATE_STATIC_REPORT_FILTER,
  FILTER_LABELS,
} from "../CandidateStaticConstants";

function CandidateStaticFilter({
  isFilterOpen,
  setIsFilterOpen,
  filters,
  setFilters,
}) {
  const dispatch = useDispatch();
  const [isDateRangeOpen, setIsDateRangeOpen] = useState(true);
  const [isSalesPersonsOpen, setIsSalesPersonsOpen] = useState(true);
  const [isRecruiterOpen, setIsRecruiterOpen] = useState(true);
  const [isClientOpen, setIsClientOpen] = useState(true);
  const [isCountryOpen, setIsCountryOpen] = useState(true);
  const [isCurrentStageOpen, setIsCurrentStageOpen] = useState(true);
  const [isFilterCleared, setIsFilterCleared] = useState(false);
  const candidateStaticReportFilterMeta = useSelector(
    (state) => state.CandidateReducer.candidateStaticReportFilterMeta
  );

  useEffect(() => {
    dispatch(fetchUsers());
    dispatch(fetchAccountNamesAll());
    dispatch(fetchCountryCurrency());
  }, []);

  const handleFilterChange = (filterName, data) => {
    const filterDataNew = filters?.map((filter) => {
      if (filter?.label === filterName) {
        return { ...filter, ...data };
      }
      return filter;
    });
    setFilters(filterDataNew);
  };

  const getFilterOptionData = (filterName) => {
    return filters?.find((filter) => filter?.label === filterName);
  };

  const handleApplyFilter = async () => {
    dispatch(
      saveCandidateStaticReportFilters({
        payload: {
          filters,
        },
        closeFilter: closeFilter,
      })
    );
  };

  const handleClearFilter = () => {
    setFilters(INITAL_CANDIDATE_STATIC_REPORT_FILTER);
    setIsFilterCleared(true);
  };

  const closeFilter = () => {
    setIsFilterOpen(false);
  };

  return (
    <Offcanvas
      isOpen={isFilterOpen}
      scrollable
      toggle={() => closeFilter()}
      direction="end"
      className="candidate-static-filter-offcanvas"
      backdrop={true}
      fade={false}
    >
      <div className="offcanvas-header pb-0 mb-0">
        <div className="d-flex flex-row justify-content-between align-items-end w-100">
          <span className="csf-title">Filter</span>
          <span>
            <Button
              className="csf-clear me-2"
              onClick={() => handleClearFilter()}
            >
              Clear
            </Button>
            <Button className="csf-apply" onClick={() => handleApplyFilter()}>
              {/* Apply */}
              {candidateStaticReportFilterMeta?.isLoading ? (
                <Spinner size="sm" color="light" />
              ) : (
                "Apply"
              )}
            </Button>
          </span>
        </div>
      </div>
      <OffcanvasBody className="mt-1 pt-0">
        <hr />
        <Row className="mb-3">
          <Col>
            <div
              className="d-flex flex-row justify-content-between cursor-pointer w-100"
              onClick={() => setIsDateRangeOpen(!isDateRangeOpen)}
            >
              <span className="fw-semibold">Date Range</span>{" "}
              <span
                className={`${
                  isDateRangeOpen ? "mdi mdi-menu-up" : "mdi mdi-menu-down"
                }`}
              ></span>
            </div>
            <Collapse isOpen={isDateRangeOpen} className="mt-2">
              <DateRangeFilter
                onRetrieveDateRangeData={handleFilterChange}
                value={getFilterOptionData(FILTER_LABELS.dateRange)}
                isFilterCleared={isFilterCleared}
                setIsFilterCleared={setIsFilterCleared}
              />
            </Collapse>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <div
              className="d-flex flex-row justify-content-between cursor-pointer w-100"
              onClick={() => setIsSalesPersonsOpen(!isSalesPersonsOpen)}
            >
              <span className="fw-semibold">Sales Person</span>{" "}
              <span
                className={`${
                  isSalesPersonsOpen ? "mdi mdi-menu-up" : "mdi mdi-menu-down"
                }`}
              ></span>
            </div>
            <Collapse isOpen={isSalesPersonsOpen} className="mt-2">
              <SalesFilter
                onRetrieveSalesData={handleFilterChange}
                value={getFilterOptionData(FILTER_LABELS.salesPerson)}
                isFilterCleared={isFilterCleared}
                setIsFilterCleared={setIsFilterCleared}
              />
            </Collapse>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <div
              className="d-flex flex-row justify-content-between cursor-pointer w-100"
              onClick={() => setIsRecruiterOpen(!isRecruiterOpen)}
            >
              <span className="fw-semibold">Recruiter</span>{" "}
              <span
                className={`${
                  isRecruiterOpen ? "mdi mdi-menu-up" : "mdi mdi-menu-down"
                }`}
              ></span>
            </div>
            <Collapse isOpen={isRecruiterOpen} className="mt-2">
              <RecruiterFilter
                onRetrieveRecruiterData={handleFilterChange}
                value={getFilterOptionData(FILTER_LABELS.recruiter)}
                isFilterCleared={isFilterCleared}
                setIsFilterCleared={setIsFilterCleared}
              />
            </Collapse>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <div
              className="d-flex flex-row justify-content-between w-100 cursor-pointer"
              onClick={() => setIsClientOpen(!isClientOpen)}
            >
              <span className="fw-semibold">Client</span>{" "}
              <span
                className={`${
                  isClientOpen ? "mdi mdi-menu-up" : "mdi mdi-menu-down"
                }`}
              ></span>
            </div>
            <Collapse isOpen={isClientOpen} className="mt-2">
              <ClientFilter
                onRetrieveClientData={handleFilterChange}
                value={getFilterOptionData(FILTER_LABELS.client)}
                isFilterCleared={isFilterCleared}
                setIsFilterCleared={setIsFilterCleared}
              />
            </Collapse>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <div
              onClick={() => setIsCountryOpen(!isCountryOpen)}
              className="d-flex flex-row justify-content-between w-100 cursor-pointer"
            >
              <span className="fw-semibold">Country</span>{" "}
              <span
                className={` ${
                  isCountryOpen ? "mdi mdi-menu-up" : "mdi mdi-menu-down"
                }`}
              ></span>
            </div>
            <Collapse isOpen={isCountryOpen} className="mt-2">
              <CountryFilter
                onRetrieveCountryData={handleFilterChange}
                value={getFilterOptionData(FILTER_LABELS.country)}
                isFilterCleared={isFilterCleared}
                setIsFilterCleared={setIsFilterCleared}
              />
            </Collapse>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <div
              onClick={() => setIsCurrentStageOpen(!isCurrentStageOpen)}
              className="d-flex flex-row justify-content-between w-100 cursor-pointer"
            >
              <span className="fw-semibold">Current Stage</span>{" "}
              <span
                className={` ${
                  isCurrentStageOpen ? "mdi mdi-menu-up" : "mdi mdi-menu-down"
                }`}
              ></span>
            </div>
            <Collapse isOpen={isCurrentStageOpen} className="mt-2">
              <CurrentStageFilter
                onRetrieveCurrentStageData={handleFilterChange}
                value={getFilterOptionData(FILTER_LABELS.currentStage)}
                isFilterCleared={isFilterCleared}
                setIsFilterCleared={setIsFilterCleared}
              />
            </Collapse>
          </Col>
        </Row>
      </OffcanvasBody>
    </Offcanvas>
  );
}

export default CandidateStaticFilter;
